<template>
  <div class="doc">
    <div class="doc-head">
      <h3>OPEN API</h3>
      <div class="doc-head-bottom"></div>
    </div>

    <div class="doc-default">
      <div
          class="doc-default-item"
          :class="[{'disabled': item.disabled, 'arcopen-pointer': item.title}]"
          v-for="item in openApi"
          :key="item.name"
          @click="handleClick(item)"
      >
        <doc-card :render="item"></doc-card>
      </div>
    </div>

    <div class="doc-head">
      <h3>客户端 SDK</h3>
      <div class="doc-head-bottom"></div>
    </div>

    <div class="doc-default">
      <div
          class="doc-default-item arcopen-pointer"
          :class="[{'disabled': item.disabled}]"
          v-for="item in appSDK"
          :key="item.name"
          @click="handleClick(item)"
      >
        <doc-card :render="item"></doc-card>
      </div>
    </div>

    <div class="doc-head">
      <h3>运营指南</h3>
      <div class="doc-head-bottom"></div>
    </div>

    <div class="doc-default">
      <div
          class="doc-default-item arcopen-pointer"
          v-for="item in managerApi"
          :class="[{'disabled': item.disabled}]"
          :key="item.name"
          @click="handleClick(item)"
      >
        <doc-card :render="item"></doc-card>
      </div>
    </div>

    <div class="doc-head">
      <h3>更多支持</h3>
      <div class="doc-head-bottom"></div>
    </div>

     <div class="doc-default">
      <div v-for="item in moreApi" :key="item.name" @click="item.title && handleClick(item)" class="doc-default-item">
        <box :render="item"></box>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/components/Card";
import Box from "@/components/Box";
import Chufa from "@/assets/icon/chufa.png"
import Box1 from "@/assets/icon/box_1.png"
import Box2 from "@/assets/icon/box_2.png"
import Box3 from "@/assets/icon/box_3.png"
import Box4 from "@/assets/icon/box_4.png"
import ChufaRule from "@/assets/icon/chufa_rule.png"
import ManageRule from "@/assets/icon/manage_rule.png"
import AuthIcon from "@/assets/icon/auth_icon.png"
import ApiUser from "@/assets/icon/api_user.png"
import ApiVideo from "@/assets/icon/api_video.png"
import IosSdk from "@/assets/icon/ios_sdk.png"
import AndroidSdk from "@/assets/icon/android_sdk.png"
import ServeSdk from "@/assets/icon/serve_sdk.png"
import OpenData from "@/assets/icon/open_data.png"
import ZhuanLan from "@/assets/icon/zhuan_lan.png"
import HuDong from "@/assets/icon/hu_dong.png"
// import ApiInteractive from "@/assets/icon/api_interactive.png"
// import ApiData from "@/assets/icon/api_data.png"
// import ApiLife from "@/assets/icon/api_life.png"

export default {
  name: "doc",
  components: {
    "doc-card": Card,
    "box": Box,
  },
  data: () => {
    return {
      appSDK: [{
        title: "IOS SDK",
        content: "包括B站账号授权功能",
        icon: IosSdk,
        url: 'https://openhome.bilibili.com/doc/4/67901da7-ffab-1be0-f615-c0138ce974a5'
      },{
        title: "Android SDK",
        content: "包括B站账号授权功能",
        icon: AndroidSdk,
        url: 'https://openhome.bilibili.com/doc/4/1f1cd948-de8f-6a9f-3b9c-2cb484da3cbb'
      },{
        title: "服务端 SDK",
        content: "包括服务端多语言的SDK",
        icon: ServeSdk,
        url: 'https://github.com/bilibili-openplatform/demo'
      },],
      openApi: [
        {
          title: "账号授权",
          content: "包括B站账号授权、账号绑定的能力",
          icon: AuthIcon,
          url: 'http://openhome.bilibili.com/doc/4/eaf0e2b5-bde9-b9a0-9be1-019bb455701c'
        },
        {
          title: "用户管理",
          content: "包括获取用户公开信息的能力",
          icon: ApiUser,
          url: 'http://openhome.bilibili.com/doc/4/feb66f99-7d87-c206-00e7-d84164cd701c'
        },
        {
          title: "视频管理",
          content: "包括视频稿件的发布、删除和查询的能力",
          icon: ApiVideo,
          url: 'http://openhome.bilibili.com/doc/4/0c532c6a-e6fb-0aff-8021-905ae2409095'
        },
        {
          title: "数据开放",
          content: "包括用户授权后的用户数据、稿件数据等能力",
          icon: OpenData,
          url: 'https://openhome.bilibili.com/doc/4/90936ab5-7c06-e24f-2ad0-0fd6e10c7386'
        },
        {
          title: "专栏管理",
          content: "包括专栏稿件的发布、删除和查询的能力",
          icon: ZhuanLan,
          url: 'https://openhome.bilibili.com/doc/4/b14b77b6-8889-8c8b-2e83-17c5a4c550fb'
        },
        {
          title: "互动管理",
          content: "包括私信、评论管理的能力",
          icon: HuDong,
          url: ''
        },
      ],
      managerApi: [
        {
          title: "运营规范",
          content: "包括哔哩哔哩开放平台的运营规范及相关介绍",
          icon: ManageRule,
          disabled: false,
          url: 'http://openhome.bilibili.com/doc/4/6b917ce7-f2d6-57b8-57df-cf0887540cef'
        },
        {
          title: "处罚规则",
          content: "关于违反开放平台运营规范的处罚说明",
          icon: ChufaRule,
          disabled: true,
          url: 'http://openhome.bilibili.com/doc/4/1fb5cc0b-3404-9354-66fe-b8b4b0428887'
        },
        {
          title: "处罚公告",
          content: "针对违反规则开发者的处罚公告",
          icon: Chufa,
          disabled: true,
          url: 'http://openhome.bilibili.com/doc/4/2f361c1e-72f0-36f0-3e68-093b730b57e6'
        }
      ],
      moreApi: [
        {
          title: "状态码",
          content: "接口的状态码查询",
          icon: Box1,
          url: 'https://openhome.bilibili.com/doc/4/7a8b80aa-56e1-5217-d7fc-c2df468ff2f7'
        },{
          title: "沙盒环境",
          content: "帮助开发者快速体验开放平台功能",
          icon: Box2,
          url: 'https://openhome.bilibili.com/doc/4/758446c7-2aee-008a-295f-51ba3445c95a'
        },{
          title: "Webhooks",
          content: "用户事件触发反向通知的机制",
          icon: Box3,
          url: 'https://openhome.bilibili.com/doc/4/b369a652-0e26-8ddb-74f0-20c74234fcd6'
        },{
          title: "常见问题",
          content: "关于开放平台的常见问题答疑",
          icon: Box4,
          url: ''
        },{
        },{
        }
      ]
    };
  },
  mounted() {
    this.$LogReport.sendCustomEvent('openplat_techcenter_page_load')
  },
  methods: {
    handleClick(item) {
      if(!item.title) return
      switch (item.title) {
        case '账号管理':
          this.$LogReport.sendCustomEvent('openplat_openapi_accountmanage_click')
          break
        case '用户管理':
          this.$LogReport.sendCustomEvent('openplat_openapi_usermanage_click')
          break
        case '视频管理':
          this.$LogReport.sendCustomEvent('openplat_openapi_videomanage_click')
          break
        case '运营规范':
          this.$LogReport.sendCustomEvent('openplat_operatestandard_click')
          break
        case '处罚规则':
          this.$LogReport.sendCustomEvent('openplat_punishrule_click')
          break
        case '处罚公告':
          this.$LogReport.sendCustomEvent('openplat_punishnotice_click')
          break
      }
      if(!item.url) return this.$message({
        content: '该功能暂未开放，敬请期待',
        type: 'success'
      })
      window.open(item.url)
      switch (item.title) {
        case '账号管理':
          this.$LogReport.sendCustomEvent('openplat_openapi_accountmanage_click')
          break
        case '用户管理':
          this.$LogReport.sendCustomEvent('openplat_openapi_usermanage_click')
          break
        case '视频管理':
          this.$LogReport.sendCustomEvent('openplat_openapi_videomanage_click')
          break
        case '运营规范':
          this.$LogReport.sendCustomEvent('openplat_operatestandard_click')
          break
        case '处罚规则':
          this.$LogReport.sendCustomEvent('openplat_punishrule_click')
          break
        case '处罚公告':
          this.$LogReport.sendCustomEvent('openplat_punishnotice_click')
          break
      }
    }
  }
};
</script>

<style scoped lang="scss">
.doc {
  min-width: 960px;
  max-width: 1440px;
  box-sizing: border-box;
  margin: 0 auto;
  padding-bottom: 88px;
}

.doc-head {
  padding: 62px 0 26px;
  text-align: center;

  h3 {
    font-size: 28px;
    color: #222222;
    line-height: 32px;
  }

  .doc-head-bottom {
    width: 48px;
    height: 4px;
    background-image: linear-gradient(270deg, #FFFFFF 0%, #CCCCCC 100%);
    margin: 4px auto 0;
  }
}

.doc-default {
  display: flex;
  margin-top: 32px;
  flex-wrap: wrap;
  margin-bottom: -20px;

  &-item {
    width: 448px;
    flex-basis: 448px;
    margin-right: 32px;
    margin-bottom: 36px;

    &.disabled {
      filter: grayscale(1);
    }
  }

  &-item:nth-child(3n) {
    margin-right: 0;
    margin-bottom: 0;
  }
}

@media (max-width: 1446px) {
  .doc-default {
    justify-content: center;

    .doc-default-item {
      width: 360px;
      // flex-basis: 360px;
      flex-basis: calc(33% - 64px);
      max-width: 360px;
    }
  }
}
</style>
